export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-drag/src/constant.js
// module id = 1356
// module chunks = 0